import { useState } from "react";
import { Box, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { useAuth } from "../Context/authContext";
import theme from "../Styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import ProjectReports from "../Components/Accounting/projectReports";
import ProjectConfirmation from "../Components/Accounting/projectConfirmation";

const AccountingDashboard = () => {
  const { user } = useAuth();
  const [tab, setTab] = useState(0);

  if (
    !user ||
    (!user.userData.userRoles.includes("Accounting") &&
      !user.userData.userRoles.includes("Administrator"))
  ) {
    window.location.href = "/";
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Header />
        <Toolbar sx={{ height: "120px" }} />
        <Box sx={{ m: 2, mx: 10 }}>
          <Typography variant="h4" gutterBottom>
            Accounting Dashboard
          </Typography>
          <Tabs
            value={tab}
            onChange={(event, newValue) => {
              setTab(newValue);
            }}
            indicatorColor="primary"
          >
            <Tab label="Project Reports" />
            <Tab label="Waiting for Confirmation" />
          </Tabs>
        </Box>
        <Box>
          {tab === 0 && <ProjectReports />}
          {tab === 1 && <ProjectConfirmation />}
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default AccountingDashboard;
